module.exports = __webpack_public_path__ + "media/images/401playlogo-7fc2cf6b.png";